import React from 'react';
import Title from '../../../../@casino/ui/title';
import { useRouter } from '../../../../@casino/useRouter';
import classes from './style.module.css';
import { useForm, useWatch } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import InputText from './components/InputText';
import CheckboxSwitch from './components/CheckboxSwitch';
import { setGetProviderById } from '../../../store/games/thunk/setGetProviderById';
import { setPutProviders } from '../../../store/games/thunk/setPutProviders';

const CreateProviders = () => {
    const router = useRouter();
    const dispatch = useDispatch();

    const handleClick = () => {
        router.history.push('/providers/list')
    }

    const { register, handleSubmit, control, reset, getValues } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        defaultValues: {
            id: '',
            name: '',
            is_deleted: false,
            is_disabled: false
        },
    })

    const [id] = useWatch({
        control,
        name: ['id']
    })

    React.useEffect(() => {
        dispatch(setGetProviderById({
            id: router.query.id
        }));
    }, [])

    const onSubmit = (store) => {
        dispatch(setPutProviders(store));
    }

    const get_provider_by_id = useSelector((state) => state.games.get_provider_by_id);

    React.useEffect(() => {
        reset({
            ...get_provider_by_id
        })
    }, [get_provider_by_id]);

    if (!id) {
        return <></>
    }

    return (
        <div className={classes.root}>
            <Title
                label="Изменить провайдера"
                labelBtn="Назад"
                button={handleClick}
            />
            <form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
                <InputText
                    name="name"
                    register={register}
                    label="Название"
                    placeholder="Название"
                />
                <div className={classes.form__wrap_switch}>
                    <CheckboxSwitch
                        register={register}
                        control={control}
                        name="is_deleted"
                        label="Признак удаленности"
                    />
                    <CheckboxSwitch
                        register={register}
                        control={control}
                        name="is_disabled"
                        label="Признак отключения"
                    />
                </div>
                <div className={classes.form__wrap_submit}>
                    <button type="submit" className={classes.submit}>
                        <span>Сохранить</span>
                    </button>
                </div>
            </form>
        </div>
    )
}

export default CreateProviders;